import { observer } from "mobx-react";
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { alertBox } from "../../../actions/alertBox";
import { request } from "../../../request";
import { AuthRequest, LoginObject, RequestObject } from "../../../interface";
import { store } from "../../../store";
import { store as uiStore } from "../../../store/ui";
import { catchEndpoint } from "../../../catchEndpoint";

@observer
class BaseForm extends React.Component<
    {
        statename?: string;
        method?: string;
        path?: string;
        load?: boolean;
        login?: boolean;
        handleResponse?: (data) => boolean | Promise<void>;
        handleLoaded?: (d) => void;
        to?: string;
        sendtype?: "form";
        noValidate?: boolean;
        /** Enable this to prevent for submission and view JSON as an alert. */
        review?: boolean;
    } & React.FormHTMLAttributes<HTMLFormElement> &
        RouteComponentProps
> {
    // Deep search for errors
    public hasErrors(state: object, depth = 0) {
        for (const e in state) {
            const stateName = `_error_${e}`;
            if (stateName in state) {
                const err = String(state[stateName]);
                if (err && !err.startsWith("++")) {
                    alertBox(err).catch(() => {
                        store.doNotice("An unexpected error occurred");
                    });
                    return true;
                }
            }
            if (depth < 3 && typeof state[e] === "object") {
                const embeddedErr = this.hasErrors(state[e] as object, depth + 1);
                if (embeddedErr) {
                    return true;
                }
            }
        }
        return false;
    }
    public handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        const { onSubmit, method, path, login, to, sendtype, noValidate } = this.props;
        e.preventDefault();
        if (onSubmit) {
            const res = onSubmit(e) as unknown as boolean;
            if (!res) {
                return;
            }
        }
        if (uiStore) {
            const state = uiStore.loginForm;

            if (!noValidate && this.hasErrors(state)) {
                return;
            }

            const data: RequestObject<AuthRequest> = {
                path: path || "null",
                method,
                sendtype,
                onError: (resp, msg: string) => {
                    alertBox(msg).catch(() => {
                        store.doNotice("An unexpected error occurred");
                    });
                }
            };

            if (login) {
                data.username = state.username;
                data.psw = state.psw;
            } else {
                data.data = state;
            }

            if (path) {
                this.sendRequest(data).catch(catchEndpoint);
            }
        }
        if (to) {
            this.props.history.push(to);
        }
    };

    public sendRequest = async (data: RequestObject<AuthRequest>): Promise<void> => {
        const { handleResponse } = this.props;
        const res = await request<LoginObject, AuthRequest>(data);

        if (handleResponse) {
            const r = await handleResponse(res);
            if (r === false) {
                return;
            }
        }
        if (!res) {
            return;
        }
    };

    public render() {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { children, staticContext, ...other } = this.props;
        return (
            <form onSubmit={this.handleSubmit} {...other}>
                {children}
            </form>
        );
    }
}

const Form = withRouter(BaseForm);

export { Form };
